import * as React from 'react';

import { CustomDataGrid } from "../../styles/style";

export default function TableDataGrid(props) {
    const { rows, columns, rowCount, paginationModel, getRowId } = props;

    return (
        <CustomDataGrid
            rows={rows}
            columns={columns}
            rowCount={rowCount}
            getRowId={getRowId}
            getRowClassName={(params) => {
                if (params.row.in_progress && params.indexRelativeToCurrentPage === 0 && paginationModel?.page === 0) {
                  return 'highlight-row';
                }
                return '';
            }}
            sx={{
                '& .highlight-row': {
                    backgroundColor: 'primary.light',
                }
            }}
            // pagination
            // paginationMode="server"
            // paginationModel={paginationModel}
            // onPaginationModelChange={(model) => setPaginationModel(model)}
            hideFooter
            pageSizeOptions={[]} // ✅ ตัวเลือกให้ user เปลี่ยนเองได้
            disableColumnFilter // ปิด panel filter
            disableColumnMenu  // ปิด menu dropdown (3 จุด) ที่มุมหัวตาราง
            disableColumnSelector // ปิดการเลือก column
            disableRowSelectionOnClick // ปิดการเลือก row ที่คลิก
        />
    );
}